import React from 'react'

const SonyPVW2650 = () => {
  return (
    <div>SonyPVW2650</div>
  )
}

export default SonyPVW2650